/**
 * A shower system's trim on one shower (step 3b,
 * claude-docs/2026-10-30-shower-systems-step3b-plan.md): where it runs and
 * how many feet of it there are. Pure: no I/O, and nothing from the
 * definitions, so `index.js` can re-export it.
 *
 * In the procedural shower's frame the walls stand at the back and, by wall
 * count, at either end: an alcove (3) has two inside corners and runs along
 * the back and both ends; a corner shower (2) one corner, the back and one
 * end; a single-wall shower (1) no corner, the back alone. Anything else —
 * a tub/shower, which carries no wall count — takes no trim yet.
 */

const FT_M = 0.3048;

/** `{ corners, runsM }`: its inside corners and the length of each wall run. */
function showerTrimRuns(shower) {
  const width = shower?.dimensions?.x ?? 0;
  const depth = shower?.dimensions?.z ?? 0;
  switch (shower?.wallCount) {
    case 3:
      return { corners: 2, runsM: [width, depth, depth] };
    case 2:
      return { corners: 1, runsM: [width, depth] };
    case 1:
      return { corners: 0, runsM: [width] };
    default:
      return { corners: 0, runsM: [] };
  }
}

/**
 * Feet of `trim` on `shower` whose panels top out `panelTopM` above its
 * floor: up each corner for corner trim, along every run for the rest. 0
 * with no panel top.
 */
function showerTrimFeet(trim, shower, panelTopM) {
  if (!(panelTopM > 0)) return 0;
  const { corners, runsM } = showerTrimRuns(shower);
  const metres =
    trim?.runs === 'corners'
      ? corners * panelTopM
      : runsM.reduce((sum, m) => sum + m, 0);
  return metres / FT_M;
}

module.exports = { showerTrimRuns, showerTrimFeet };
